import { render, staticRenderFns } from "./FlightLeg.vue?vue&type=template&id=45a7807e&scoped=true"
import script from "./FlightLeg.vue?vue&type=script&lang=js"
export * from "./FlightLeg.vue?vue&type=script&lang=js"
import style0 from "./FlightLeg.vue?vue&type=style&index=0&id=45a7807e&prod&lang=scss"
import style1 from "./FlightLeg.vue?vue&type=style&index=1&id=45a7807e&prod&lang=scss&scoped=true"
import style2 from "./FlightLeg.vue?vue&type=style&index=2&id=45a7807e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a7807e",
  null
  
)

export default component.exports